<template>
    <div class="layout-wrapper" :class="containerClass">
        <AppSidebar />
        <div class="layout-main-container">
            <AppTopbar />
            <div class="layout-main">
                <RouterView />
            </div>
            <AppFooter />
        </div>
        <div class="layout-mask" />
    </div>
</template>

<script setup lang="ts">
    import { computed, watch } from 'vue'

    import { useLayout } from '../layout'

    import AppFooter from './AppFooter.vue'
    import AppSidebar from './AppSidebar.vue'
    import AppTopbar from './AppTopbar.vue'

    // data
    const { layoutConfig, layoutState, isSidebarActive } = useLayout()

    // methods
    const outsideClickListener = (event: Event) => {
        const sidebarEl = document.querySelector('.layout-sidebar')
        const topbarEl = document.querySelector('.layout-menu-button')

        if (sidebarEl && topbarEl) {
            layoutState.staticMenuMobileActive.value = (sidebarEl.isSameNode(event.target as HTMLElement) || sidebarEl.contains(event.target as HTMLElement) || topbarEl.isSameNode(event.target as HTMLElement) || topbarEl.contains(event.target as HTMLElement))
        } else {
            layoutState.staticMenuMobileActive.value = false
        }
    }

    // computed
    const containerClass = computed(() => {
        return {
            'layout-theme-light': !layoutConfig.darkTheme.value,
            'layout-theme-dark': layoutConfig.darkTheme.value,
            'layout-static-inactive': layoutState.staticMenuDesktopInactive.value,
            'layout-mobile-active': layoutState.staticMenuMobileActive.value
        }
    })

    // watcher
    watch(isSidebarActive, (newVal) => {
        if (newVal) {
            document.addEventListener('click', outsideClickListener)
        } else {
            document.removeEventListener('click', outsideClickListener)
        }
    })
</script>
